import { render, staticRenderFns } from "./72.vue?vue&type=template&id=296f52d0&scoped=true&"
import script from "./72.vue?vue&type=script&lang=js&"
export * from "./72.vue?vue&type=script&lang=js&"
import style0 from "./72.vue?vue&type=style&index=0&id=296f52d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f52d0",
  null
  
)

export default component.exports